export enum PriceType {
    Custom = 1,
    Standard = 0
}

export namespace PriceType {
    export function values() {
        return Object.keys(PriceType).filter((type) => isNaN(<any>type) && type !== 'values');
    }
}